import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { QUILl_OPTIONS } from './quill.config';
import Quill from 'quill';

@Component({
  selector: 'flow-form-rich-text-editor',
  templateUrl: `form-rich-text-editor.component.html`,
  styleUrls: ['./form-rich-text-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormRichTextEditor implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() placeholder = '';
  @Input() required: boolean = false;
  @Input() infoTooltip = '';
  @Input() isDisabled: boolean = false;
  @Input() labelClass?: string;
  @Input() height: string = '150px';
  @Input() characterLimit = 500;

  value: string = '';
  editorOptions = QUILl_OPTIONS;
  quill!: Quill;
  characterCount = 0;

  constructor(@Optional() @Self() protected control: NgControl, private cdr: ChangeDetectorRef) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value || '';
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.cdr.markForCheck();
  }

  onEditorChange() {
    this.updateCharacterCount();
    if (this.characterCount > this.characterLimit) {
      const currentContent = this.quill.getText();
      const truncatedContent = currentContent.substring(0, this.characterLimit);
      this.quill.setText(truncatedContent);
      this.quill.setSelection(this.characterLimit, 0);
    }
  }

  onContentChange(content: string): void {
    this.value = content;
    this.onChange(content);
    this.onTouched();
  }

  updateCharacterCount() {
    if (this.quill) {
      this.characterCount = this.quill.getText().trim().length;
    }
  }

  onEditorCreated(quill: any): void {
    this.quill = quill;
    this.updateCharacterCount();

    const editor = quill.container.querySelector('.ql-editor');
    editor.style.height = this.height;
  }
}
